// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"4ee890b8","727":"2c3914ef"}[chunkId] + ".chunk.js";
};